const buildInvitationLink = (photobookUrlIdentifier) => (`${window.location.origin}/photobook/${photobookUrlIdentifier}#photos`);

export default buildInvitationLink;
